import { render } from "./DesktopNav.vue?vue&type=template&id=0807c23e&scoped=true"
import script from "./DesktopNav.vue?vue&type=script&lang=js"
export * from "./DesktopNav.vue?vue&type=script&lang=js"

import "./DesktopNav.vue?vue&type=style&index=0&id=0807c23e&scoped=true&lang=css"

import exportComponent from "/builds/sats/careers-application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0807c23e"]])

export default __exports__